import Header from "../Header";
import Footer from "../Footer";
import React from "react";
import { Outlet } from "react-router-dom";
import { TitleProvider, useTitle } from "../provider/TitleProvider";
import { ThemeProvider } from "../provider/ThemeProvider";

const MainLayout = () => {
  const TitleDisplay = () => {
    const { title } = useTitle();
    if (!!title) {
      return (
        <section className="page-title style-main">
          <div className="auto-container">
            <h2>{title}</h2>
          </div>
        </section>
      );
    }
  };

  return (
    <ThemeProvider attribute="class" forcedTheme="light" disableTransitionOnChange>
      <Header />
      <div className="flex w-full min-h-svh">
        <div className="flex-1 flex flex-col">
          <TitleProvider>
            <div className="d-flex flex-column flex-fill">
              <TitleDisplay />
              <div className="flex-1 overflow-auto p-4">
                <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
                  <div className="w-full max-w-sm md:max-w-3xl">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </TitleProvider>
        </div>
      </div>
      <Footer />
    </ThemeProvider>
  );
};

export default MainLayout;
